module.exports = __webpack_public_path__ + "static/gnolls_summon_demons-eec401e9963ad9cb82afdd4df1a347b8.png";